// extracted by mini-css-extract-plugin
module.exports = {"FeedbackSuccessPage__content":"FeedbackSuccessPage_FeedbackSuccessPage__content__27QSm","FeedbackSuccessPage__actions":"FeedbackSuccessPage_FeedbackSuccessPage__actions__2p6C6"};